import './MicActivationSection.css';
import { useMicActivation, type MicActivation } from '../../hooks/useMicActivation';

/**
 * V2 Voice GM (2026-06-02) — mic activation picker.
 *
 * Sits inside AudioPanel below VoicePickerSection. Lets the user pick
 * between toggle (click-to-start, click-to-stop) and push-to-talk
 * (hold-to-talk). Mirrors vibe-designer's settings.activation pattern.
 */

export interface MicActivationSectionProps {
  testidPrefix?: string;
}

const OPTIONS: Array<{ value: MicActivation; label: string; description: string }> = [
  {
    value: 'toggle',
    label: 'Toggle (click)',
    description: 'Click 🎤 once to start, click again to stop.',
  },
  {
    value: 'ptt',
    label: 'Push-to-talk (hold)',
    description: 'Press and hold 🎤 to record, release to stop.',
  },
];

export function MicActivationSection({
  testidPrefix = 'br-mic-activation',
}: MicActivationSectionProps) {
  const [activation, setActivation] = useMicActivation();

  return (
    <section
      className="br-scenario-drawer-section br-mic-activation"
      data-testid={testidPrefix}
    >
      <h3 className="br-label">Mic activation</h3>
      <fieldset className="br-mic-activation-fieldset">
        <legend className="sr-only">Mic activation mode</legend>
        {OPTIONS.map((opt) => (
          <label
            key={opt.value}
            className="br-mic-activation-option"
            data-testid={`${testidPrefix}-${opt.value}`}
          >
            <input
              type="radio"
              name="mic-activation"
              value={opt.value}
              checked={activation === opt.value}
              onChange={() => setActivation(opt.value)}
            />
            <span className="br-mic-activation-label">{opt.label}</span>
            <span className="br-mic-activation-description br-label">
              {opt.description}
            </span>
          </label>
        ))}
      </fieldset>
    </section>
  );
}

export default MicActivationSection;
